import request from '@/utils/request'

/**
 * 添加角色信息
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function roleAdd(data) {
  return request({
    type: 'base',
    url: 'role/add',
    method: 'post',
    data
  })
}
/**
 * 获取角色信息
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function roleAllplatformGet(data) {
  return request({
    type: 'base',
    url: 'role/allplatform/get',
    method: 'post',
    data
  })
}
/**
 * 删除角色信息
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function roleDelete(data) {
  return request({
    type: 'base',
    url: 'role/delete',
    method: 'post',
    data
  })
}
/**
 * 获取角色信息
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function roleGet(data) {
  return request({
    type: 'base',
    url: 'role/get',
    method: 'post',
    data
  })
}
/**
 * 获取角色信息列表
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function roleListGet(data) {
  return request({
    type: 'base',
    url: 'role/list/get',
    method: 'post',
    data
  })
}
/**
 * 获取角色信息列表
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function roleListSelectGet(data) {
  return request({
    type: 'base',
    url: 'role/list/select/get',
    method: 'post',
    data
  })
}
/**
 * 删除角色的菜单信息
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function roleMenuDelete(data) {
  return request({
    type: 'base',
    url: 'role/menu/delete',
    method: 'post',
    data
  })
}
/**
 * 获取角色信息下拉表列表（带权限）
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function roleOptionLimitListGet(data) {
  return request({
    type: 'base',
    url: 'role/option/limit/list/get',
    method: 'post',
    data
  })
}
/**
 * 获取角色信息下拉表列表（不带权限）
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function roleOptionListGet(data) {
  return request({
    type: 'base',
    url: 'role/option/list/get',
    method: 'post',
    data
  })
}
/**
 * 修改角色信息
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function roleUpdate(data) {
  return request({
    type: 'base',
    url: 'role/update',
    method: 'post',
    data
  })
}
/**
 * 添加某个角色下的用户权限
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function roleUserAdd(data) {
  return request({
    type: 'base',
    url: 'role/user/add',
    method: 'post',
    data
  })
}
/**
 * 添加或修改角色的用户信息
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function roleUserAddUpdate(data) {
  return request({
    type: 'base',
    url: 'role/user/add/update',
    method: 'post',
    data
  })
}
/**
 * 删除某个角色下的用户权限信息
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function roleUserDelete(data) {
  return request({
    type: 'base',
    url: 'role/user/delete',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/Role.js